import { component, demoFile } from 'system/demo';

import { BlocklistHelpModal } from '../blocklistdialogs';

demoFile('open-modules/zdf/component/blocklist/blocklist-dialogs');

component('BlocklistHelpModal', BlocklistHelpModal, { args: { onClose: () => {} } });
